import React, {useEffect, useState, useCallback} from 'react';
import {web3} from 'decentralized/web3.js';
import {bytes32ToIPFSHash, ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {SEQUENCE_ANNOTATION} from 'constants/annotation-types.js';
import {connect} from 'react-redux';
import PulseLoader from 'react-spinners/PulseLoader'
import ipfs from 'decentralized/Ipfs.js';
import ethereum from 'decentralized/ethereum.js';
import { Input } from 'reactstrap';

const contentCache = {};

const AnnotationEditor = ({
    work,
    contentId=work && work.newSequence,
    numPending,
    linkType=SEQUENCE_ANNOTATION,
    color}) => {
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);
    const [annotations, setAnnotations] = useState([]);

    const onChange = useCallback((e) => {
        setText(e.target.value);
    }, [setText]);

    const submit = useCallback(() => {
        ethereum.xanadu.newAnnotationContent(
            linkType,
            contentId,
            text)
            .then(x => setLoading(true));
        setText('');
        setLoading(true);
    }, [contentId, text, setText, setLoading]);

    useEffect(() => {
        if (!contentId) {
            return;
        }
        ethereum.xanadu.getAnnotations(
            linkType,
            contentId)
            .then(a => {
                setAnnotations(a);
            });
    }, [contentId, setAnnotations, numPending]);

        let style = {
        };
        if (color) {
            style.backgroundColor = color;
        }
    return (
        <div>
          <Input
            style={style}
            className="annotation-text" onChange={onChange} type="textarea" value={text}/>
          <div
            style={style}
            onClick={submit} className="submit-button">
            Annotate
          </div>
          <div
            style={style}
            className="annotations">
            <PulseLoader
              sizeUnit={"px"}
              size={10}
              color={'#42f4f1'}
              loading={numPending > 0}
            />
 
            {annotations.map(
                a =>
                    <Annotation
                      style={style}
                      key={a.annotationData}
                      annotation={a}/>)}
          </div>
        </div>
    );
};

const Annotation = ({annotation, style}) => {
    const [content, setContent] = useState('');
    const [userName, setUserName] = useState('');
    useEffect(() => {
        let h = web3.utils.fromAscii(annotation.annotationData);
        let hash = bytes32ToIPFSHash(h);
        if (contentCache[hash]) {
            setContent(contentCache[hash]);
        } else {
            ipfs.getJson(hash)
                .then(s => {
                    contentCache[hash] = s;
                    setContent(s);
                });
        }

        ethereum.users.getUserName(annotation.address)
            .then(n => setUserName(n));

    }, [annotation, setContent, setUserName]);

    return (
        <div
          style={style}
          className="annotation">
          <div className="author">
            {userName}: 
          </div>
          <div className="content">
            {content}
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        numPending: state.transactions.pendingTransactions.length
   }
};

export default connect(mapStateToProps, null)(AnnotationEditor);


